import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { EstimationSystem, Home, MyLeaves, Login, Users, VehicleDetails, LeaveManagement, ForgotPassword, ResetPassword, Setting, Analytics, Maps, PrivacyPolicy, DeletePrivacyPolicy, DeleteAccountInfo } from '../Screens'
import { MenuLayout } from '../Components'
import allPaths from './paths'
import { Result, Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { setLanguage } from '../Redux/actions/languageActions'

const Page404 = (props) => {
  const { history } = props
  return (
    <Result
      status='404'
      title='404'
      subTitle='Sorry, the page you visited does not exist.'
      extra={
        <Button
          type='primary'
          className='form-button'
          onClick={() => history.push(allPaths?.HOME)}
        >
          Back Home
        </Button>
      }
    />
  )
}

const Routes = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.authReducer.user)
  const language = useSelector(state => state.language.language)
  useEffect(() => {
    if (!language) {
      dispatch(setLanguage('it'))
    }
  }, [dispatch, language])

  return (
    <Router>
      <Switch>

        <Route path={allPaths?.LOGIN} language={language} setLanguage={setLanguage} exact component={Login} />
        <MenuLayout path={allPaths?.HOME} language={language} setLanguage={setLanguage} exact component={Home} />
        <MenuLayout path={allPaths?.ESTIMATION_SYSTEM} language={language} setLanguage={setLanguage} exact component={EstimationSystem} />
        <MenuLayout path={allPaths?.USER} language={language} exact component={Users} />
        <MenuLayout path={allPaths?.MY_LEAVES} language={language} exact component={MyLeaves} />
        <MenuLayout path={allPaths?.PROFILE} language={language} exact component={Setting} />
        <MenuLayout path={allPaths?.LEAVE_MANEGEMENT} language={language} exact component={LeaveManagement} />
        <MenuLayout path={allPaths?.MAP} language={language} exact component={Maps} />
        <Route path={allPaths?.FORGOT_PASSWORD} exact component={ForgotPassword} />
        <Route path={allPaths?.PRIVACY_POLICY} exact component={PrivacyPolicy} />
        <Route path={allPaths?.DELETE_PRIVACY_POLICY} exact component={DeletePrivacyPolicy} />
        <Route path={allPaths?.DELETE_ACCOUNT_INFO} exact component={DeleteAccountInfo} />
        <Route path={`${allPaths?.RESET_PASSWORD}/:token`} exact component={ResetPassword} />
        <MenuLayout path={`${allPaths?.VEHICLE_DETAILS}/:vehicleId`} language={language} exact component={VehicleDetails} />
        <MenuLayout path={`${allPaths?.ANALYTICS}`} language={language} exact component={Analytics} />
        <Route path='*' exact component={Page404} />
      </Switch>
    </Router>
  )
}

export { Routes, Page404 }
